import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { TinyMceInputProps } from './Types';
import InputLabel from './InputLabel';
import showdown from 'showdown';
import { useTranslation } from 'react-i18next';
import { convertMarkdownToHtml } from '@wajeez-web/core/utils';

const TinyMCEInput = React.forwardRef<Editor, TinyMceInputProps>(
  (
    {
      value = '',
      disabled,
      height,
      name,
      label,
      onChange,
      required,
      placeholder,
    }: TinyMceInputProps,
    ref
  ) => {
    const { t } = useTranslation();

    return (
      <div>
        {label && <InputLabel text={label} name={name} required={required} />}
        <Editor
          apiKey={process.env['NX_TINYMCE_APIKEY_VAR']}
          ref={ref}
          value={convertMarkdownToHtml(value || '')}
          disabled={disabled || false}
          init={{
            placeholder: t(
              `inputs.placeholders.${placeholder}`,
              placeholder || ''
            ) as string,
            directionality: 'rtl',
            height: height || 250,
            menubar: false,
            invalid_elements: 'table,td,tr,th',
            text_patterns: [
              { start: '*', end: '*', format: 'italic' },
              { start: '**', end: '**', format: 'bold' },
              { start: '#', format: 'h1' },
              { start: '##', format: 'h2' },
              { start: '###', format: 'h3' },
              { start: '####', format: 'h4' },
              { start: '#####', format: 'h5' },
              { start: '######', format: 'h6' },
              // The following text patterns require the `lists` plugin
              { start: '1. ', cmd: 'InsertOrderedList' },
              { start: '* ', cmd: 'InsertUnorderedList' },
              { start: '- ', cmd: 'InsertUnorderedList' },
              { start: '~', end: '~', cmd: 'createLink' },
            ],
            // advlist_bullet_styles: 'default', // only include square bullets in list
            plugins: [
              // 'textpattern',
              'paste',
              'lists',
              'fullscreen',
              'searchreplace',
              // 'advlist', // doesn't support arabic by default
              'autolink',
              'link',
              'visualblocks',
              'code',
              'emoticons',
              'insertdatetime',
              'media',
              'table',
              'help',
              'wordcount',
              'directionality',
            ],
            toolbar:
              'undo redo | formatselect | bold italic | numlist bullist | link emoticons | removeformat',
            automatic_uploads: true,
          }}
          onEditorChange={(val: string) => {
            onChange(name, val);
          }}
        />
      </div>
    );
  }
);

export default TinyMCEInput;
